export class SIQNoNetworkBannnerTheme {
  backgroundColor = "null";
  textColor = "null";
  loaderColor = "null";
}
//# sourceMappingURL=SIQNoNetworkBannnerTheme.js.map